import { render } from "./UnassignedClientsTable.vue?vue&type=template&id=39f5d4ca&ts=true"
import script from "./UnassignedClientsTable.vue?vue&type=script&lang=ts"
export * from "./UnassignedClientsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
